import React from "react";
import styled from "styled-components";
import { CheckCircleOutlined, SafetyOutlined, CustomerServiceOutlined } from "@ant-design/icons";

const BookUsSection = styled.div`
  padding-top: 7rem;
  padding-left: 8rem;
  padding-right: 8rem;
  padding-bottom: 7rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

const SectionHeader = styled.h2`
  color: #000;
  text-align: left;
  margin: 0;
  font-size: 24px;
  font-weight: 700;
`;

const FeaturesContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const FeatureCard = styled.div`
  background: #e4f4ff;
  border-radius: 12px;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  position: relative;
`;

const CardHeader = styled.h3`
  color: #000;
  font-size: 18px;
  font-weight: 600;
  margin: 0;
`;

const CardText = styled.p`
  color: #666;
  font-size: 14px;
  line-height: 1.5;
  margin: 0;
`;

const LearnMoreLink = styled.a`
  color: #1890ff;
  font-size: 14px;
  text-decoration: underline;
  cursor: pointer;
  align-self: flex-start;
  margin-top: 2rem;
`;

const CardIcon = styled.div`
  position: absolute;
  top: 1.5rem;
  right: 1.5rem;
  font-size: 24px;
  color: #1890ff;
`;

const features = [
  {
    title: "Instant booking",
    description: "Book online immediately, no need to request!",
    icon: <CheckCircleOutlined />,
  },
  {
    title: "Secure payments",
    description: "Your transactions are 100% safe and protected",
    icon: <SafetyOutlined />,
  },
  {
    title: "24/7 Support",
    description: "Our team is always available to assist you",
    icon: <CustomerServiceOutlined />,
  },
];

const BookUs: React.FC = () => {
  return (
    <BookUsSection>
      <SectionHeader>Why book with us?</SectionHeader>

      <FeaturesContainer>
        {features.map((feature, index) => (
          <FeatureCard key={index}>
            <CardIcon>{feature.icon}</CardIcon>
            <CardHeader>{feature.title}</CardHeader>
            <CardText>{feature.description}</CardText>
            <LearnMoreLink>Learn more</LearnMoreLink>
          </FeatureCard>
        ))}
      </FeaturesContainer>
    </BookUsSection>
  );
};

export default BookUs;
